exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--8-oneOf-1-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--8-oneOf-1-2!bootstrap/dist/css/bootstrap.css"), "");

// module
exports.push([module.id, "h3[data-v-50430ef4]{font-weight:700;box-sizing:border-box;margin:28px 15px .75em 15px!important;flex:0 0 calc(100% - 30px)!important;padding:.25em 0!important;border-bottom:1px solid var(--light-200)}h3[data-v-50430ef4]:first-of-type{margin-top:0!important}", ""]);

// exports
